/* Quiet Ring — custom cursor (vanilla port of CustomCursor.jsx) */
(function () {
  if (window.matchMedia("(hover: none)").matches) return;

  var dot = document.createElement("div");
  dot.className = "qr-cursor-dot";
  var ring = document.createElement("div");
  ring.className = "qr-cursor-ring";
  document.body.appendChild(ring);
  document.body.appendChild(dot);

  gsap.set([dot, ring], { opacity: 0 });

  var dotX = gsap.quickTo(dot, "x", { duration: 0.08, ease: "power3" });
  var dotY = gsap.quickTo(dot, "y", { duration: 0.08, ease: "power3" });
  var ringX = gsap.quickTo(ring, "x", { duration: 0.45, ease: "power3" });
  var ringY = gsap.quickTo(ring, "y", { duration: 0.45, ease: "power3" });

  var revealed = false;

  window.addEventListener("mousemove", function (e) {
    dotX(e.clientX);
    dotY(e.clientY);
    ringX(e.clientX);
    ringY(e.clientY);
    if (!revealed) {
      revealed = true;
      gsap.to([dot, ring], { opacity: 1, duration: 0.3 });
    }
  });

  document.addEventListener("mouseover", function (e) {
    if (e.target.closest("[data-cursor-hover]")) ring.classList.add("is-hover");
  });
  document.addEventListener("mouseout", function (e) {
    if (e.target.closest("[data-cursor-hover]")) ring.classList.remove("is-hover");
  });
})();
